import DSBox from '../../design-system/DSBox';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import useMenuButton from './hooks/useMenuButton';
import DSMenuIconButton from '../../design-system/DSMenuIconButton';
import DSMenu from '../../design-system/DSMenu';
import DSMenuItem from '../../design-system/DSMenuItem';
import DSTooltip from '../../design-system/DSTooltip';

export type MenuItemsProps = {
  onClick: () => void;
  isDisabled: boolean;
  title: string;
  tooltip?: string;
};

type MenuButtonProps = {
  menuItems: MenuItemsProps[];
};

const MenuButton = ({ menuItems }: MenuButtonProps) => {
  const { anchorElement, isMenuOpen, handleMenuClick, handleMenuClose } =
    useMenuButton();
  return (
    <DSBox>
      <DSMenuIconButton
        onClick={handleMenuClick}
        aria-controls={isMenuOpen ? 'basic-menu' : undefined}
        aria-haspopup="true"
        aria-expanded={isMenuOpen ? 'true' : undefined}
      >
        <MoreVertIcon />
      </DSMenuIconButton>
      <DSMenu
        anchorEl={anchorElement}
        open={isMenuOpen}
        onClose={handleMenuClose}
        sx={{ mt: 1 }}
        // `sx` on Menu lands on the Popover root, so a `padding` there does
        // nothing. The MenuList is what carries the default vertical padding.
        MenuListProps={{ sx: { paddingY: 0 } }}
      >
        {menuItems.map((button) => {
          const menuItem = (
            <DSMenuItem
              key={button.title}
              disabled={button.isDisabled}
              onClick={() => {
                button.onClick();
                handleMenuClose();
              }}
            >
              {button.title}
            </DSMenuItem>
          );
          return button.tooltip ? (
            <DSTooltip
              key={button.title}
              title={button.tooltip}
              placement="top"
            >
              <DSBox component="span" sx={{ display: 'block', width: '100%' }}>
                {menuItem}
              </DSBox>
            </DSTooltip>
          ) : (
            menuItem
          );
        })}
      </DSMenu>
    </DSBox>
  );
};

export default MenuButton;
